import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { CommitToStoresAndCompletePurchaseLogDto } from "@interfaces/commitToStoresAndCompletePurchaseLogDto.interface";
import { PurchaseLogLineItem } from "@interfaces/purchaseLogLineItem.interface";
import { Service } from "@services/service";
import { Guid } from "guid-typescript";

@Injectable()
export class StockStoreService extends Service {
	constructor(injector: Injector) {
		super("StockStore", injector);
	}

	// API
	app_CheckIn(id: Guid, quantity: number, code: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_CheckIn/${id}/${quantity}/${code}`, {});
	}

	app_CheckOut(id: Guid, quantity: number, code: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_CheckOut/${id}/${quantity}/${code}`, {});
	}
	
	app_CommitToStoresAndCompletePurchaseLog(data: CommitToStoresAndCompletePurchaseLogDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_CommitToStoresAndCompletePurchaseLog`, data);
	}

	app_PlacedItem(id: Guid, location: string) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_PlaceItem/${id}/${location}`,{});
	}

	app_Received(id: number, item: PurchaseLogLineItem) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_Received/${id}`, item);
	}

	checkIn(id: number, quantity: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/CheckIn/${id}/${quantity}`, {});
	}

	checkOut(id: number, quantity: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/CheckOut/${id}/${quantity}`, {});
	}

	getAllByLogId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetAllByLogId/${id}`);
	}

	getByItemId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByItemId/${id}`);
	}

	getDetails(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/Details/${id}`);
	}

	getInStock() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/InStock`);
	}

	purchaseLogLineItemReceived(id: number, item: PurchaseLogLineItem) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/PurchaseLogLineItemReceived/${id}`, item);
	}

	purchaseLogReceived(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/PurchaseLogReceived/${id}`, {});
	}
}